import { render, staticRenderFns } from "./listaPedidos.vue?vue&type=template&id=5b475df4&scoped=true&"
import script from "./listaPedidos.vue?vue&type=script&lang=js&"
export * from "./listaPedidos.vue?vue&type=script&lang=js&"
import style0 from "./listaPedidos.vue?vue&type=style&index=0&id=5b475df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b475df4",
  null
  
)

export default component.exports